export default "__VITE_ASSET__41740f97__"